import {
    Dialog,
    ScreenMessagePanelContainer,
    Label,
    ButtonLight,
    ButtonStandard,
    MultiSelectComboBox,
    formatMessage,
    RadioButton,
    Flexbox,
} from 'cw-ui-core';
import css from './NewManageRolesDialog.scss';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React from 'react';
import _ from 'lodash';

export const NEW_MANAGE_ROLE_USER_DIALOG = 'NEW_MANAGE_ROLE_USER_DIALOG';

const NewManageRolesDialog = ({
    usersCount = 0,
    setValueOnPath,
    onCancel,
    onApply,
    option,
    manageRoles,
    onChangeOption,
    rolesList,
    rolesValue,
}) => {
    const setRole = filter => {
        setValueOnPath('rolesSelected', filter);
    };

    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={onCancel}
        />,
        <ButtonStandard
            key="apply"
            automationName="apply"
            className={css.applyButton}
            value={formatMessage(Locale.apply)}
            onClick={onApply}
            disabled={!(option !== undefined && !_.isEmpty(rolesValue))}
        />,
    ];

    return (
        <Dialog
            dialogId={NEW_MANAGE_ROLE_USER_DIALOG}
            header={formatMessage(Locale.updateRoleDialogHeader)}
            buttons={dialogButtons}>
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer
                        className={css.screenMessage}
                        screenKey={NEW_MANAGE_ROLE_USER_DIALOG}
                    />
                    <Label value={formatMessage(Locale.updateRoleDialogDercription)} />
                    <div className={css.userCountText}>{formatMessage(Locale.usersSelected, { usersCount })}</div>
                    <Flexbox className={css.radioButtonsContainer}>
                        {/* IAM-7263 Remove Ability to Assign Identity Roles */}
                        {/* <RadioButton */}
                        {/*    automationName="addRoleRadioButton" */}
                        {/*    value={{ */}
                        {/*        id: manageRoles[0].id, */}
                        {/*        name: manageRoles[0].name, */}
                        {/*        checked: option === manageRoles[0].id, */}
                        {/*    }} */}
                        {/*    onChange={onChangeOption} */}
                        {/* /> */}
                        <RadioButton
                            automationName="removeRoleRadioButton"
                            value={{
                                id: manageRoles[1].id,
                                name: manageRoles[1].name,
                                checked: option === manageRoles[1].id,
                            }}
                            onChange={onChangeOption}
                        />
                    </Flexbox>
                    <Label isLink className={css.clearLabel} onClick={() => setRole([])}>
                        {formatMessage(Locale.clear)}
                    </Label>
                    <MultiSelectComboBox
                        cwId="rolesDropDown"
                        automationName="rolesDropDown"
                        items={rolesList}
                        expandOnClick
                        readOnly
                        value={rolesValue}
                        onChange={filter => setRole(filter)}
                        placeholder={formatMessage(Locale.selectRole)}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default NewManageRolesDialog;
